import { Link } from 'react-router-dom';
import { heroData } from '@/mocks/homeData';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Modern%20minimalist%20digital%20security%20abstract%20background%20with%20soft%20warm%20gradients%20in%20coral%20and%20amber%20tones%2C%20subtle%20geometric%20patterns%2C%20shield%20motif%20with%20glowing%20accents%2C%20clean%20professional%20atmosphere%2C%20no%20text%2C%20cinematic%20lighting%2C%208k%20quality&width=1600&height=900&seq=hero-91-2026&orientation=landscape"
          alt="91官网安全认证背景"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className="flex items-center justify-center gap-3 mb-6">
          {['ri-shield-check-line', 'ri-verified-badge-line', 'ri-shield-star-line'].map((icon, i) => (
            <div key={i} className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-2xl bg-white/15 backdrop-blur-sm">
              <i className={`${icon} text-2xl text-white`}></i>
            </div>
          ))}
        </div>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 font-heading tracking-tight">
          {heroData.title}
        </h1>
        <p className="text-lg md:text-xl text-white/80 mb-3 font-heading">
          {heroData.subtitle}
        </p>
        <p className="text-sm md:text-base text-white/65 max-w-2xl mx-auto mb-8 leading-relaxed">
          {heroData.description}
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#"
            className="px-8 py-3.5 bg-white text-primary-600 font-semibold rounded-lg hover:bg-white/90 transition-all duration-300 whitespace-nowrap cursor-pointer text-sm shadow-lg"
          >
            <i className="ri-external-link-line mr-2"></i>
            {heroData.primaryButton}
          </a>
          <Link
            to="/category/anquan"
            className="px-8 py-3.5 border-2 border-white/40 text-white font-medium rounded-lg hover:bg-white/10 hover:border-white/60 transition-all duration-300 whitespace-nowrap cursor-pointer text-sm"
          >
            {heroData.secondaryButton}
          </Link>
        </div>

        <div className="mt-10 flex items-center justify-center gap-6 md:gap-10">
          {[
            { value: '1000万+', label: '服务用户' },
            { value: '8年+', label: '稳定运营' },
            { value: '99.99%', label: '服务可用率' },
          ].map((stat, i) => (
            <div key={i} className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-white font-heading">{stat.value}</div>
              <div className="text-xs md:text-sm text-white/55 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}